__turbopack_context__.v({
  "box": "select-module__fYzkpa__box",
  "chevron": "select-module__fYzkpa__chevron",
  "placeholder": "select-module__fYzkpa__placeholder",
  "select": "select-module__fYzkpa__select",
  "trigger": "select-module__fYzkpa__trigger",
});
